var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

cover();
featured();
logoMarquee();

document.addEventListener('DOMContentLoaded', setupFootnotes);

pagination(false);

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover') && !document.querySelector('.cover').classList.contains('half')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

if (document.querySelector('.cover') && document.querySelector('.cover').classList.contains('half')) {
    body.classList.add('portal-visible');
}

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function cover() {
    'use strict';
    var cover = document.querySelector('.cover');
    if (!cover) return;

    imagesLoaded(cover, function () {
        cover.classList.remove('image-loading');
    });

    document.querySelector('.cover-arrow').addEventListener('click', function () {
        var element = cover.nextElementSibling;
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 30,
        loop: false,
        nav: false,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function logoMarquee() {
    'use strict';
    const marqueeContainer = document.getElementById('logo-marquee');
    if (!marqueeContainer) return;
    
    const logoContainer = marqueeContainer.querySelector('.logo-list-container');
    if (!logoContainer) return;
    
    // Clone logos to create a seamless loop
    const originalLogos = logoContainer.innerHTML;
    logoContainer.innerHTML = originalLogos + originalLogos + originalLogos;
    
    const logoItems = logoContainer.querySelectorAll('.kg-image-card');
    if (!logoItems.length) return;
    
    // Calculate total width of one set of logos
    let singleSetWidth = 0;
    const logoCount = logoItems.length / 3;
    
    for (let i = 0; i < logoCount; i++) {
        const style = window.getComputedStyle(logoItems[i]);
        const width = parseFloat(style.width);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        singleSetWidth += width + marginLeft + marginRight;
    }
    
    // Set initial position
    let currentPosition = 0;
    let animationId;
    let isPaused = false;
    let speed = window.innerWidth > 768 ? 1 : 0.5; // pixels per frame, slower on mobile
    
    // Make sure container is wide enough and positioned correctly
    logoContainer.style.width = (singleSetWidth * 3) + 'px';
    
    // Animation function with smoother reset logic
    function animate() {
        if (!isPaused) {
            currentPosition -= speed;
            
            // Reset position for seamless loop when first set is off-screen
            if (Math.abs(currentPosition) >= singleSetWidth) {
                // Reset by exactly one set width for seamless transition
                currentPosition = currentPosition + singleSetWidth;
            }
            
            logoContainer.style.transform = `translateX(${currentPosition}px)`;
        }
        animationId = requestAnimationFrame(animate);
    }
    
    // Start animation with a slight delay to ensure proper initialization
    setTimeout(() => {
        animationId = requestAnimationFrame(animate);
    }, 100);
    
    // Pause on hover
    marqueeContainer.addEventListener('mouseenter', () => {
        isPaused = true;
    });
    
    marqueeContainer.addEventListener('mouseleave', () => {
        isPaused = false;
    });
    
    // Adjust speed on window resize
    window.addEventListener('resize', () => {
        speed = window.innerWidth > 768 ? 0.4 : 0.2;
    });
    
    // Clean up on page leave
    window.addEventListener('beforeunload', () => {
        cancelAnimationFrame(animationId);
    });
}

function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}


document.addEventListener("DOMContentLoaded", () => {
    const goTopButton = document.querySelector(".go-top");

    if (!goTopButton) return;

    const updateGoTopVisibility = () => {
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const threshold = Math.min(300, Math.max(80, maxScroll / 2));

        if (maxScroll > 80 && window.scrollY > threshold) {
            goTopButton.classList.add("is-visible");
        } else {
            goTopButton.classList.remove("is-visible");
        }
    };

    updateGoTopVisibility();
    window.addEventListener("scroll", updateGoTopVisibility);
    window.addEventListener("resize", updateGoTopVisibility);

    goTopButton.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
});
